var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef, } from 'react';
import Icon from '../icon';
import Spinner from '../spinner';
import { ButtonIconContainer, ButtonLoadingContainer } from './styles/button.styled';
const buttonIsButton = (props) => {
    return !('href' in props);
};
export const ButtonIcon = forwardRef((_a, ref) => {
    var { className, variant = 'on-light', dataTest = `button-${variant}`, color, loading = false } = _a, rest = __rest(_a, ["className", "variant", "dataTest", "color", "loading"]);
    let icon;
    let props;
    if ('icon' in rest) {
        const { icon: iconProp } = rest, restProps = __rest(rest, ["icon"]);
        icon = _jsx(Icon, { variant: iconProp, size: "lg" });
        props = restProps;
    }
    else {
        const { children: childrenProp } = rest, restProps = __rest(rest, ["children"]);
        icon = childrenProp;
        props = restProps;
    }
    if (loading) {
        icon = (_jsx(ButtonLoadingContainer, { "$variant": variant, children: _jsx(Spinner, { size: "small", inverted: variant !== 'on-light' }) }));
    }
    if (buttonIsButton(props)) {
        const { type: typeProp, disabled } = props, otherProps = __rest(props, ["type", "disabled"]);
        return (_jsx(ButtonIconContainer, Object.assign({ "$variant": variant, "$color": color, className: className, "data-test": dataTest, as: "button", disabled: disabled || loading, type: typeProp !== null && typeProp !== void 0 ? typeProp : 'button', ref: ref }, otherProps, { children: icon })));
    }
    return (_jsx(ButtonIconContainer, Object.assign({ "$variant": variant, "$color": color, className: className, "data-test": dataTest, as: "a", ref: ref }, props, { children: icon })));
});
ButtonIcon.displayName = 'ButtonIcon';
